<template>
<div>
<Adviser/>

</div>
</template>

<script>
import Adviser from "../../components/academic/Adviser.vue";


export default {
  components: {
   Adviser
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>